<h3 mat-dialog-title>
    <span class="dialog-title-text">{{ data.title }}</span>
    <button mat-icon-button mat-dialog-close aria-label="Close" class="dialog-close-btn">
        <i class="ph-bold ph-x icon-muted icon-20" aria-hidden="true"></i>
    </button>
</h3>

<mat-dialog-content>
    <div class="legacy-html-body" [innerHTML]="data.html"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button" class="ok-btn" (click)="_dialogRef.close()">OK</button>
</mat-dialog-actions>
